import { formatISO, isValid, parseISO } from 'date-fns/esm';
/**
 * Helps yup schemas to validate dates.
 *
 * @author  Ihar Kazlouski
 * @function convertedDateToObject
 * @category helpers
 * @param {Date | number | string | undefined} date  date.
 * @param {'complete' | 'date' | 'time'} representation representation format date.
 * @return {Date | undefined} return parsed date.
 */

var convertedDateToObject = function convertedDateToObject(date, representation) {
  if (!date || !isValid(date)) {
    return undefined;
  }

  var newDate = typeof date === 'string' ? parseISO(date) : date;
  return parseISO(formatISO(newDate, {
    representation: representation || 'date'
  }));
};

export { convertedDateToObject };